import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { BaseService } from './base.service';
import { environment } from '../../environments/environment';
import { BaseQueryParams } from '../models/BaseQueryParams';
import { CompanyYear } from '../models/CompanyYear';

@Injectable({
  providedIn: 'root',
})
export class CompanyYearService extends BaseService<CompanyYear> {
  public selectedCompanyYear$: Observable<CompanyYear>;
  public currentYear$: Observable<CompanyYear>;

  private selectedCompanyYearSubject: BehaviorSubject<CompanyYear>;
  private currentYearSubject: BehaviorSubject<CompanyYear>;
  //new observables for CY
  public companyYear: BehaviorSubject<CompanyYear>;
  public year$: Observable<CompanyYear>;

  constructor(httpClient: HttpClient) {
    super(
      httpClient,
      `${environment.apiUrl}/company-year/v1`,
      new BaseQueryParams('', 'year', 0, 100, false, true),
    );

    this.selectedCompanyYearSubject = new BehaviorSubject<CompanyYear>(
      new CompanyYear(),
    );
    this.selectedCompanyYear$ = this.selectedCompanyYearSubject.asObservable();
    this.currentYearSubject = new BehaviorSubject<CompanyYear>(
      new CompanyYear(),
    );
    this.currentYear$ = this.currentYearSubject.asObservable();
    this.companyYear = new BehaviorSubject<CompanyYear>(new CompanyYear());
    this.year$ = this.companyYear.asObservable();
  }

  // this method updates CY globally
  public updateCompanyYear(updatedYear: CompanyYear) {
    this.companyYear.next(updatedYear);
  }

  public selectCompanyYear(companyYear: CompanyYear): void {
    this.selectedCompanyYearSubject.next(companyYear);
  }

  public setCurrentYear(companyYear: CompanyYear): void {
    this.currentYearSubject.next(companyYear);
  }
}
